import React from 'react';
import styles from './Treatments.module.scss';
import api from '../../../helpers/api';
import Loader from '../../../components/miscellaneous/Loader/Loader';
import { BiCollapse, BiExpand } from 'react-icons/bi';
import { FiInfo } from 'react-icons/fi';
import { $t } from '../../../helpers/translator';
import Tooltip from '../../../components/miscellaneous/Tooltip/Tooltip';
import ClinicTreatmentsProtocolsCalculator from "../../../components/clinic/TreatmentsProtocolsCalculator/TreatmentsProtocolsCalculator";
import TreatmentsTable from "../../../components/TreatmentsTable/TreatmentsTable";


class ClinicTreatments extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            areasLoading: false,
            areasRowFlexState: 'nowrap'
        };
    }

    async componentDidMount() {
        await this.getAreasAndNumbers();
    }

    async getAreasAndNumbers() {
        this.setState({ areasLoading: true }, async () => {
            try {
                // let res = await api.getAreasWithTreatmentCount();
                let res = await api.get('/treatments/perarea');
                if (res.data && res.data.success) {
                    this.setState({ areas: res.data.data });
                }
            } catch (e) {
                console.error('err getting single platform', e);
            } finally {
                this.setState({ areasLoading: false });
            }
        });
    }

    closeModals() {
        this.setState({ showFirmwareUpdateModal: false });
    }

    toggleFlexStateAreas() {
        let newState = 'nowrap';
        if (this.state.areasRowFlexState === 'nowrap') {
            newState = 'wrap';
        }

        this.setState({ areasRowFlexState: newState });
    }

    renderProtocolText() {
        return (
            <div className={ 'alma-box' }>
                <div className={ 'alma-box-header' }>
                    <div><h3>{ $t('global.treatments.TreatmentTypesAndProtocols') }</h3></div>
                </div>
                <div className={ 'alma-box-content' }>
                    <div>{ $t('global.treatments.explain1') }</div>
                    <div>{ $t('global.treatments.explain2') }</div>
                    <div>{ $t('global.treatments.explain3') }</div>
                    <div>{ $t('global.treatments.explain4') }</div>
                    <div>{ $t('global.treatments.explain5') }</div>
                </div>
            </div>
        );
    }

    renderAreasBar() {
        return (
            <div className={ 'alma-box' }>
                <div className={ 'alma-box-header' }>
                    <div><h3>{ $t('global.treatments.treatmentsCount') }</h3></div>
                    <div className={ `${styles[ 'areas-expand' ]}` } onClick={ () => this.toggleFlexStateAreas() }>
                        { this.state.areasRowFlexState === 'wrap' ?
                            <BiCollapse />
                            :
                            <BiExpand />
                        }
                    </div>
                </div>
                <div className={ 'alma-box-content' }>
                    <div>
                        { $t('global.treatments.treatmentsCountInfo') }
                    </div>
                    { this.state.areas ?
                        <div className={ `${styles[ 'areas-container' ]}` } style={ { flexWrap: this.state.areasRowFlexState } }>
                            { this.state.areas.map((v, k) => (
                                <div className={ `${styles[ 'area-container' ]}` } key={ k }>
                                    <div className={ `${styles[ 'center-image' ]}` }>
                                        <div className={ `${styles[ 'image-container' ]}` }
                                            style={ {
                                                background: 'url(\'' + v.image + '\')  50% 0% no-repeat',
                                                backgroundSize: 'cover',
                                                position: 'relative',
                                            } }>
                                            <div className={ `${styles[ 'circle-text-overlay' ]}` }>
                                                { v[ 'count_sessions' ] }
                                            </div>
                                        </div>
                                    </div>
                                    <div className={ `${styles[ 'area-name' ]}` }>{ $t('global.areas.' + v.areaName) }</div>
                                </div>
                            )) }
                        </div>
                        :
                        <Loader />
                    }
                </div>
            </div>
        );
    }

    renderPretreatmentProtocols() {
        return (
            <div className={ 'alma-box' }>
                <div className={ 'alma-box-header' }>
                    <div><h3>{ $t('global.treatments.pretreatmentProtocols') }</h3></div>
                    <div>

                        <Tooltip
                            content={ $t('global.treatments.pretreatmentProtocolsInfo') }>
                            <FiInfo className={ `${styles[ 'info-icon' ]}` } />
                        </Tooltip>
                    </div>
                </div>
                <div className={ 'alma-box-content' }>
                    <ClinicTreatmentsProtocolsCalculator />
                </div>
            </div>
        );
    }


    render() {
        return (
            <div className={ `${styles[ 'container' ]}` }>
                <div>
                    <div className={ `${styles[ 'row' ]}` }>
                        <div className={ `${styles[ 'left-flex-item' ]}` }>
                            <div className={ `${styles[ 'box' ]}` }>
                                { this.renderProtocolText() }
                            </div>
                            <div className={ `${styles[ 'box' ]}` }>
                                { this.renderAreasBar() }
                            </div>
                        </div>
                        <div className={ `${styles[ 'box' ]}` }>
                            { this.renderPretreatmentProtocols() }
                        </div>

                    </div>

                    <div className={ `${styles[ 'row' ]}` }>
                        <div className={ `${styles[ 'box' ]}` }>
                            <TreatmentsTable userType={ 2 } header={ $t('global.treatments.clinicTreatments') } />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ClinicTreatments;
